import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

export default class AboutImagesSlider {
  constructor() {
    this.el = document.querySelector(".js-about-images-swiper");
    this.swiper = null;
    this.init();
  }

  init() {
    if (!this.el) return;
    this.swiper = new Swiper(this.el, {
      modules: [Autoplay, Navigation, Pagination],
      loop: true,
      speed: 600,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: this.el.querySelector(".js-about-images-next"),
        prevEl: this.el.querySelector(".js-about-images-prev"),
      },
      pagination: {
        el: this.el.querySelector(".js-about-images-pagination"),
        clickable: true,
      },
    });
  }
}
